import Http from "./http";

export const createEmailTemplateAPI = (data) => {
  return Http.post("admin/email-templates/createTemplate",data);
};
